<template>
<el-popover
  placement="bottom"
  trigger="click"
>
  <template>
    <div class="site-selector-wrapper">
      <ul class="site-selector-list">
        <li
          v-for="site in sites"
          :key="site.id"
          class="site-selector"
        >
          <el-checkbox v-model="query.siteIds" :label="site.id">{{site.name}}</el-checkbox>
        </li>
      </ul>

      <select-ctrl-group
        :ids="query.siteIds"
        :options="sites"
        style="padding-bottom:0;"
      />
    </div>
  </template>
  <template #reference>
    <el-button size="small">选择站房</el-button>
  </template>
</el-popover>
</template>

<script>
import SelectCtrlGroup from '../../SelectCtrlGroup/index'
export default {
  name: 'SiteQuery',
  components: {SelectCtrlGroup},
  props: {
    sites: {
      required: true,
      type: Array
    },
    query: {
      required: true,
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
.site-selector-wrapper {
  display: grid;
  grid-template-rows: minmax(calc(100% - 33px), auto) max-content;
  max-height: 300px;

  .site-selector-list {
    min: {
      width: 0;
      height: 0;
    };
    margin: 0;
    padding: 0;
    list-style: none;
    overflow: auto;

    > li {
      line-height: 1.7;
      -webkit-font-smoothing: antialiased;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/Query/SiteQuery.vue